import React from 'react';
import { Button, Card } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import type { ReactNode } from 'react';
import PageScaffold, { type PageScaffoldProps } from '../PageScaffold';
import { usePermissions } from '../../features/permissions/PermissionsContext';

export interface ListPagePrimaryAction {
  permission: string;
  label: string;
  onClick: () => void;
}

export interface ListPageProps extends PageScaffoldProps {
  /** Optional content above the card (e.g. tab switchers). */
  header?: ReactNode;
  /** Wrap table in a card surface (default true). */
  bordered?: boolean;
  /** Standard primary create action (top-right, aligned with title). */
  primaryAction?: ListPagePrimaryAction;
}

/**
 * Standard list-report page: shell chrome + optional filters + card + table body.
 */
const ListPage: React.FC<ListPageProps> = ({
  children,
  header,
  bordered = true,
  primaryAction,
  actions,
  ...scaffold
}) => {
  const { hasPermission } = usePermissions();

  const resolvedActions =
    actions ??
    (primaryAction && hasPermission(primaryAction.permission) ? (
      <Button type="primary" icon={<PlusOutlined />} onClick={primaryAction.onClick}>
        {primaryAction.label}
      </Button>
    ) : undefined);

  return (
    <PageScaffold {...scaffold} actions={resolvedActions}>
      {header}
      {bordered ? (
        <Card className="cp-list-page-card" bordered={false}>
          {children}
        </Card>
      ) : (
        children
      )}
    </PageScaffold>
  );
};

export default ListPage;
